// @flow
import React from 'react';
import { I18n } from '@lingui/react';
import styled, { type StyledComponent } from 'styled-components';

import { MQ } from '@rover/kibble/styles';

import CityInput, { type Props as CityInputProps } from '../../formFields/CityInput';

type Props = {
  ...CityInputProps,
  isUS: boolean,
};

const StyledCityInput: StyledComponent<React$ElementConfig<typeof CityInput>, {}, any> = styled(
  CityInput
)`
  flex: 2;

  ${MQ.XS} {
    margin-right: 0;
  }
`;

const AddressFormCityField = ({ isUS, ...other }: Props) => (
  <I18n>
    {({ i18n }) => (
      <StyledCityInput
        label={isUS ? i18n._('City') : i18n._('City/Town/District')}
        name="city"
        data-qa-id="input-text-address-city"
        {...other}
      />
    )}
  </I18n>
);

export default AddressFormCityField;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/AddressForm/AddressFormCityField.jsx